
import React, {Component} from "react";
import {HashRouter, Route, Switch } from "react-router-dom";
import DefaultDashboardPage from "./Pages/Dashboards/Default";
import AdjustWorkTimesPage from './Pages/AdjustWorkTimesPage';
import ToursOfferedPage from './Pages/ToursOfferedPage';
import DayTypesPage from './Pages/DayTypesPage';
import DayTypeCalendarView from './Components/DayType/DayTypeCalendarView';
import DayTypeRequestsView from './Components/DayType/DayTypeRequestsView';
import SchedulesPage from './Pages/SchedulesPage';
import AboutPage from './Pages/AboutPage';
import PostedSchedulesPage from './Components/Schedule/PostedSchedulesPage';
import ShortPostedScheduleView from './Components/Schedule/OneTwoDay/PostedScheduleView';
import LongPostedScheduleView from './Components/Schedule/SevenNineDay/PostedScheduleView';
import ShortLiveScheduleView from './Components/Schedule/OneTwoDay/LiveScheduleView';
import LongLiveScheduleView from './Components/Schedule/SevenNineDay/LiveScheduleView';
import DetailedScheduleView from './Components/Schedule/DetailedSchedule/DetailedScheduleView';
import MyQuickScheduleView from './Components/Schedule/MyQuickSchdeuleView';
import ApprovalView from './Components/Approval/ApprovalView';

import PageNotFound from './Pages/Theme/Error';
import BlankPage from "./Pages/Theme/Page";

const ServiceNow = ()=> {window.location.href ='https://nbcu.service-now.com/nbcusp?id=sc_cat_item&sys_id=a8108f526f922500e904f00dba3ee458&sysparm_appID=7039838'; return null;};

export default class AppRouter extends Component {
    
    render() {
        return (
            <HashRouter>
                <div>
                <Switch>
                    <Route exact path="/" component={DefaultDashboardPage}/>

                    {/* Schedule Domain */}
                    <Route exact path="/my-quick-schedule" component={MyQuickScheduleView}/>
                    <Route exact path="/schedules" component={SchedulesPage}/>
                    <Route exact path="/posted-schedules" component={PostedSchedulesPage}/>
                    <Route exact path="/posted-schedule-view-short" component={ShortPostedScheduleView}/>
                    <Route exact path="/posted-schedule-view-long" component={LongPostedScheduleView} />
                    <Route exact path="/live-schedule-view-short" component={ShortLiveScheduleView}/>
                    <Route exact path="/live-schedule-view-long" component={LongLiveScheduleView}/>
                    <Route exact path="/detailed-schedule-view" component={DetailedScheduleView}/>

                    {/* Adjust-Work-Times Domain */}
                    <Route exact path="/adjust-work-times" component={AdjustWorkTimesPage}/>

                    {/* Tours-Offered Domain */}
                    <Route exact path="/tours-offered" component={ToursOfferedPage}/>

                    {/* Day-Type Domain */}
                    <Route exact path="/day-types" component={DayTypesPage}/>
                    <Route exact path="/day-types-requests-view" component={DayTypeRequestsView}/>
                    <Route exact path="/day-types-calendar-view" component={DayTypeCalendarView}/>
                    <Route exact path='/service-now' component={ServiceNow}/>

                    {/* Approvals Domain */}
                    <Route exact path="/approvals" component={ApprovalView}/>

                    {/* About */}
                    <Route exact path="/about" component={AboutPage}/>

                    <Route exact path="/page" component={BlankPage}/>
                    <Route component={PageNotFound}/>
                </Switch>

                </div>
            </HashRouter>
        )
    }
}





// WEBPACK FOOTER //
// ./src/AppRouter.js